import type { RichTextConfig } from '@/core/models/richText';

/**
 * The "standard" note editor (Principles Activites dialog and the Accountant's Report notes), copied as written: the
 * hidden ids `fonts`, `orderedList` and `unorderedList` match no angular-editor button, so those buttons stay visible.
 */
export function standardNoteEditorConfig(): RichTextConfig {
  return {
    editable: true,
    spellcheck: true,
    height: '200',
    minHeight: '0',
    maxHeight: 'auto',
    width: 'auto',
    minWidth: '0',
    translate: 'yes',
    enableToolbar: true,
    showToolbar: true,
    placeholder: 'Enter text here...',
    defaultParagraphSeparator: '',
    sanitize: true,
    toolbarPosition: 'bottom',
    toolbarHiddenButtons: [
      [
        'fontName',
        'fontSize',
        'backgroundColor',
        'strikeThrough',
        'customClasses',
        'insertHorizontalRule',
        'removeFormat',
        'heading',
        'link',
        'unlink',
        'insertImage',
        'insertVideo',
        'fonts',
        'justifyLeft',
        'justifyCenter',
        'justifyRight',
        'justifyFull',
        'indent',
        'outdent',
        'orderedList',
        'unorderedList',
        'textColor',
      ],
    ],
  };
}
